
import { ChallanFormat } from "./ChallanFormat";

export const DeliveryChallan = (props) => {
    const { billDetails } = props;
    return (
        <div style={{ position: "relative" }}>
            {
                billDetails && billDetails?.map((data, i) => (
                    <ChallanFormat key={i} {...props} details={data} />
                ))
            }
        </div>
    )
}